
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire11d9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire11d9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $f8608169bc11b40a$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["1TzJS","index.349b739f.js","7YU74","pdf_worker.040d6cdf.js"]'));


// swiped from coherentpdf example code
function $8395381ed5e5a6ad$var$filedownload(data, filename, mime, bom) {
    var blobData = typeof bom !== "undefined" ? [
        bom,
        data
    ] : [
        data
    ];
    var blob = new Blob(blobData, {
        type: mime || "application/octet-stream"
    });
    if (typeof window.navigator.msSaveBlob !== "undefined") window.navigator.msSaveBlob(blob, filename);
    else {
        var blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);
        if (typeof tempLink.download === "undefined") tempLink.setAttribute("target", "_blank");
        document.body.appendChild(tempLink);
        tempLink.click();
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
}
// checking code also adapted from coherentpdf
// there's probably a better way to do this than duplicating code, but I'm not sure if I can pass in symbols that may not be set so fuckit.
function $8395381ed5e5a6ad$var$ensureEmbedDataIsSet(timeout) {
    var start = Date.now();
    return new Promise(waitForEmbedData);
    function waitForEmbedData(resolve, reject) {
        if ($8395381ed5e5a6ad$var$embedState && $8395381ed5e5a6ad$var$embedState.complete) resolve($8395381ed5e5a6ad$var$embedState);
        else if (timeout && Date.now() - start >= timeout) reject(new Error("timeout"));
        else setTimeout(waitForEmbedData.bind(this, resolve, reject), 30);
    }
}
function $8395381ed5e5a6ad$var$ensureExtractDataIsSet(timeout) {
    var start = Date.now();
    return new Promise(waitForExtractData);
    function waitForExtractData(resolve, reject) {
        if ($8395381ed5e5a6ad$var$extractState && $8395381ed5e5a6ad$var$extractState.complete) resolve($8395381ed5e5a6ad$var$extractState);
        else if (timeout && Date.now() - start >= timeout) reject(new Error("timeout"));
        else setTimeout(waitForExtractData.bind(this, resolve, reject), 30);
    }
}
var $aeb6eb219f734731$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $aeb6eb219f734731$var$url = new URL("pdf_worker.040d6cdf.js", import.meta.url);
$aeb6eb219f734731$exports = $56b621a6dd25b2cb$exports($aeb6eb219f734731$var$url.toString(), $aeb6eb219f734731$var$url.origin, true);


// Functionality to delegate to workers for appropriate tasks.  Again swiped from coherent PDF example, but for some bizarre reason the coherent PDF people had this just running as opposed to being wrapped in a function, which seems wasteful...
function $8395381ed5e5a6ad$var$embedDataInPDf() {
    $8395381ed5e5a6ad$var$ensureEmbedDataIsSet(100000).then(function() {
        document.getElementById("progress").innerHTML = "PDF File loaded from disc. Processing...";
        var arr = new Uint8Array($8395381ed5e5a6ad$var$embedState.pdf);
        var pdfName = $8395381ed5e5a6ad$var$embedState.pdfFileName;
        var modifiedPdfName = `modified-${pdfName}`;
        var w = new Worker($aeb6eb219f734731$exports);
        w.postMessage({
            mtype: "embed",
            bytes: arr,
            citations: $8395381ed5e5a6ad$var$embedState.cites,
            citesFileName: $8395381ed5e5a6ad$var$embedState.citesFileName
        });
        w.onmessage = function(e) {
            switch(e.data.mtype){
                case "pdfout":
                    $8395381ed5e5a6ad$var$filedownload(e.data.bytes, modifiedPdfName);
                    document.getElementById("progress").innerHTML = "Processing finished. Output PDF file downloaded. Reload page to do another file.";
                    w.terminate();
                    break;
                case "progress":
                    document.getElementById("progress").innerHTML = e.data.message;
                    break;
            }
        };
    });
}

function $8395381ed5e5a6ad$var$extractDataFromPDf() {
    $8395381ed5e5a6ad$var$ensureExtractDataIsSet(100000).then(function() {
        document.getElementById("progress").innerHTML = "PDF File loaded from disc. Processing...";
        var arr = new Uint8Array($8395381ed5e5a6ad$var$extractState.pdf);
        var w = new Worker($aeb6eb219f734731$exports);
        w.postMessage({
            mtype: "extract",
            bytes: arr
        });
        w.onmessage = function(e) {
            switch(e.data.mtype){
                case "dataExtracted":
                    $8395381ed5e5a6ad$var$filedownload(e.data.citations, e.data.fileName, "text/plain");
                    document.getElementById("progress").innerHTML = "Processing finished. Citaton data file downloaded. Reload page to do another file.";
                    w.terminate();
                    break;
                case "progress":
                    document.getElementById("progress").innerHTML = e.data.message;
                    break;
            }
        };
    });
}
// Setting global state and event listeners (mostly adapted from coherentpdf example)
// Global state for embedding and extracting
var $8395381ed5e5a6ad$var$embedState = function() {};
var $8395381ed5e5a6ad$var$extractState = function() {};
// hang event listener for citation file upload
const $8395381ed5e5a6ad$var$citesSelector = document.getElementById("citation-selector");
$8395381ed5e5a6ad$var$citesSelector.addEventListener("change", (event)=>{
    const citesFileList = event.target.files;
    const citesFileName = citesFileList[0].name;
    const citesReader = new FileReader();
    citesReader.addEventListener("load", (event)=>{
        var citesString = event.target.result;
        $8395381ed5e5a6ad$var$embedState.cites = citesString;
        $8395381ed5e5a6ad$var$embedState.citesFileName = citesFileName;
        if ($8395381ed5e5a6ad$var$embedState.pdf) {
            $8395381ed5e5a6ad$var$embedState.complete = true;
            $8395381ed5e5a6ad$var$embedDataInPDf();
        }
    });
    citesReader.readAsText(citesFileList[0], "UTF-8");
});
// hang event listener for embedding PDF file upload
const $8395381ed5e5a6ad$var$embedSelector = document.getElementById("embed-selector");
$8395381ed5e5a6ad$var$embedSelector.addEventListener("change", (event)=>{
    const embedList = event.target.files;
    const embedName = embedList[0].name;
    const embedReader = new FileReader();
    embedReader.addEventListener("load", (event)=>{
        const embedResult = event.target.result;
        $8395381ed5e5a6ad$var$embedState.pdf = embedResult;
        $8395381ed5e5a6ad$var$embedState.pdfFileName = embedName;
        if ($8395381ed5e5a6ad$var$embedState.cites) {
            $8395381ed5e5a6ad$var$embedState.complete = true;
            $8395381ed5e5a6ad$var$embedDataInPDf();
        }
    });
    embedReader.readAsArrayBuffer(embedList[0]);
});
// hang event listener for extraction PDF file upload
const $8395381ed5e5a6ad$var$extractSelector = document.getElementById("extract-selector");
$8395381ed5e5a6ad$var$extractSelector.addEventListener("change", (event)=>{
    const extractList = event.target.files;
    const extractReader = new FileReader();
    extractReader.addEventListener("load", (event)=>{
        const extractResult = event.target.result;
        $8395381ed5e5a6ad$var$extractState.pdf = extractResult;
        $8395381ed5e5a6ad$var$extractState.complete = true;
        $8395381ed5e5a6ad$var$extractDataFromPDf();
    });
    extractReader.readAsArrayBuffer(extractList[0]);
});


//# sourceMappingURL=index.349b739f.js.map
